import { CardHeader, Typography, Box } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getStatusDetails } from '../../components/StatusChip';
import { MessageItem } from './types';

interface MessageHeaderProps {
    dataItem: MessageItem;
}

export function MessageHeader({ dataItem }: MessageHeaderProps) {
    const statusDetails = getStatusDetails(dataItem.status);
    
    return (
        <CardHeader
            sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '& .MuiCardHeader-content': { width: '100%' }
            }}
            avatar={<Box
                sx={{
                    bgcolor: statusDetails.bgColor,
                    color: statusDetails.color,
                    p: 1,
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <FontAwesomeIcon icon={statusDetails.icon} size="lg" />
            </Box>}
            title={<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="h6" sx={{ mb: 0 }}>
                    {dataItem.title || 'Message Details'}
                </Typography>
            </Box>} 
        />
    );
}